import React from 'react';

const Pin = React.memo(props => <svg width="24" height="35" viewBox="0 0 24 35" fill="none" {...props}>
    <circle cx="12" cy="23" r="12" fill="black" fillOpacity="0.12" />
    <circle cx="12" cy="23" r="4" fill="black" fillOpacity="0.12" />
    <path fillRule="evenodd" clipRule="evenodd" d="M13 11.917C15.8377 11.441 18 8.973 18 6C18 2.68629 15.3137 0 12 0C8.68629 0 6 2.68629 6 6C6 8.973 8.16229 11.441 11 11.917V23H13V11.917Z" fill="#212121" />
</svg>);

export default Pin;

Pin.defaultProps = {
    width: '24px',
    height: '35px',
};